import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import 'bootstrap'


const isProd = process.env.NODE_ENV === 'production'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)


window.$ = require('jquery')
window.JQuery = require('jquery')

Vue.config.productionTip = false

//if (!Vue.config.productionTip) {
    Vue.use(VueAnalytics, {
        id: 'UA-59932-5',
        anonymizeIp: true,
        autoTracking: {
            screenview: true
        },
        disabled: false,
        debug: {
            enabled: !isProd,
            sendHitTask: isProd
        },
//        linkers: ['hanse-domizil.de', 'www.hanse-domizil.de', 'www.hanse-domizil.de/dist', 'localhost']
    })
//}

new Vue({
    render: h => h(App),
}).$mount('#app')
